import { gql } from '@apollo/client';

export const LOGIN_CODE = gql`
    query LoginCode {
        loginCode
    }
`
